import { render, staticRenderFns } from "./QrRender.vue?vue&type=template&id=4b9ea952&"
import script from "./QrRender.vue?vue&type=script&lang=ts&"
export * from "./QrRender.vue?vue&type=script&lang=ts&"
import style0 from "./QrRender.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports